import React from "react";
import { connect } from "react-redux";
import { Field } from "redux-form";
import {
  form,
  Form as AppForm,
  Select,
  FormTypes
} from "MODULES/shared/components/Forms";
import { ATTACHMENT_TYPE } from "APP_ROOT/constants";
import { toOptions } from "LIB/forms";
import * as actions from "../../actions/attachments";

export function AttachmentType(props) {
  const { attachmentTypes } = props;
  // Filtering out the 'external_link' key from the attachmentTypes since
  // we need the label for display purposes but do not want it to show up in
  // the dropdown for file-type attachments.
  /* eslint-disable no-unused-vars */
  const { external_link, ...filteredAttachmentTypes } = attachmentTypes;
  /* eslint-enable no-unused-vars */
  const options = toOptions(
    Object.assign(filteredAttachmentTypes, {
      other: {
        label: "Other"
      }
    })
  );

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <Field
          name={ATTACHMENT_TYPE}
          component={Select}
          label="Attachment Type"
          options={options}
          required
        />
      </AppForm.Body>
    </AppForm>
  );
}

AttachmentType.propTypes = FormTypes.modalForm;

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data =>
    dispatch(actions.update(ownProps.id, ownProps.resourceType, data))
}))(
  form({
    form: "attachmentForm"
  })(AttachmentType)
);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Attachments/AttachmentType.jsx